/**
 * Preview feature constants.
 * Values are plain strings stored per-firm in the backend database (previewFeatures: [String!]!).
 * No backend schema change is needed to add a new entry — just add the constant here and set
 * the matching string value on the firm via the admin tooling.
 */
export const PreviewFeature = {
    /** New Workspace 2.0 feature */
    NEW_WORKSPACE_20: 'NEW_WORKSPACE_20',
    /** Level of Specification Automation feature */
    LOS_AUTOMATION: 'LOS_AUTOMATION',
    /** Product Type Automation feature */
    PT_AUTOMATION: 'PT_AUTOMATION',
    /** OM Workspace - enables new workspace toggle for Office Master workspaces */
    OM_WORKSPACE: 'OM_WORKSPACE',
    /** OM Product Type Automation - controls PT deactivation UX in OM workspace */
    OM_PT_AUTOMATION: 'OM_PT_AUTOMATION',
    /** OM LOS Automation - shows Level of Specification icon in OM workspace */
    OM_LOS_AUTOMATION: 'OM_LOS_AUTOMATION',
    /** OM PT Link Automation - shows Product Type/Group link icons in OM workspace */
    OM_PT_LINK_AUTOMATION: 'OM_PT_LINK_AUTOMATION',
    /** OM Insert UOM - enables inline UOM insertion in OM workspace text paragraphs and pills */
    OM_INSERT_UOM_IN_PILL: 'OM_INSERT_UOM_IN_PILL',
    /** API Subscription Management - enables the API Subscription section on account setup */
    API_SUBSCRIPTION_MANAGEMENT: 'API_SUBSCRIPTION_MANAGEMENT',
    /** AppHarmony Header - enables the Harmony (light) header to replace main App Header */
    APP_HARMONY_HEADER: 'APP_HARMONY_HEADER',
    /** Project Tasks - enables the kanban task board and task indicators in the workspace */
    PROJECT_TASKS: 'PROJECT_TASKS',
    /** Product Ingestion Audit - enables the Product Data Issues tab on the Scraper page */
    PRODUCT_INGESTION_AUDIT: 'PRODUCT_INGESTION_AUDIT',
} as const

/** Type for preview feature values */
export type PreviewFeature = typeof PreviewFeature[keyof typeof PreviewFeature]
